module.exports = __webpack_public_path__ + "img/resumeExpand.63215e6c.svg";